export const SPREADSHEET_EXTENSIONS = 'application/pgp-signature; name=signature.asc';
